<template>
  <div id="app">
    <v-app :dark='darkTheme'>
      <BottomNavigation v-if="$vuetify.breakpoint.xsOnly"/>
      <ContentSidebar />
      <OptionsSidebar />
      <BulkRoomEditSideBar />
      <RoomAssociationSidebar />
      <searchResultSidebarNew />
      <RoomAmenitiesSidebar />
      <MainSidebar />
      <AdminSidebar />
      <PermissionsEditor />
      <LabelSidebar />
      <CollectionSidebar />
      <TopBanner v-if="!$vuetify.breakpoint.smAndDown" />
      <TopBannerPhone v-if="$vuetify.breakpoint.smAndDown"/>      
      <GlobalElevatorControl v-if="$vuetify.breakpoint.xsOnly" />
      <GlobalElevatorOpener v-if="$vuetify.breakpoint.xsOnly" />
      <router-view></router-view>
      <BuildingCard v-if="selectedBuilding"/>
      <TestDialog />
      <FileUploadDialog />
      <PhotoReview v-if="showPhotoReview"/>
      <PhotoViewerDialog />
      <SnackMessageBar />      
      <measureBtn />
    </v-app>    
  </div>
</template>

<script>
import TopBanner from '@/components/TopBanner'
import TopBannerPhone from '@/components/TopBannerPhone'
import MainSidebar from '@/components/MainSidebar'
import AdminSidebar from '@/components/AdminSidebar'
import PermissionsEditor from '@/components/PermissionsEditor'
import OptionsSidebar from '@/components/OptionsSidebar'
import CollectionSidebar from '@/components/CollectionSidebar'
import ContentSidebar from '@/components/ContentSidebar'
import RoomAssociationSidebar from '@/components/RoomAssociationSidebar'
import BulkRoomEditSideBar from '@/components/BulkRoomEditSideBar'
import LabelSidebar from '@/components/LabelSidebar'
import BuildingCard from '@/components/buildingcard/BuildingCard'
import searchResultSidebarNew from '@/components/search/searchResultSidebarNew'
import RoomAmenitiesSidebar from '@/components/roomAmenities/RoomAmenitiesSidebar'
import RoomTable from '@/components/RoomTable'
import TestDialog from '@/components/TestDialog'
import FileUploadDialog from '@/components/forms/FileUploadDialog'
import PhotoViewerDialog from '@/components/PhotoViewerDialog'
import PhotoReview from '@/components/PhotoReview'
import SnackMessageBar from '@/components/SnackMessageBar'


import GlobalElevatorControl from '@/components/GlobalElevatorControl'
import GlobalElevatorOpener from '@/components/GlobalElevatorOpener'
import BottomNavigation from '@/components/BottomNavigation'
import measureBtn from '@/components/measureButton'
import { mapState, mapMutations } from 'vuex'
import jscookie from 'js-cookie'

export default {
  components: { TopBanner, TopBannerPhone, searchResultSidebarNew, AdminSidebar, PermissionsEditor, OptionsSidebar, MainSidebar, GlobalElevatorControl, CollectionSidebar, ContentSidebar, BulkRoomEditSideBar, LabelSidebar, BuildingCard, RoomTable, TestDialog, FileUploadDialog, PhotoViewerDialog, PhotoReview, SnackMessageBar/*, MOTD*/, RoomAssociationSidebar, GlobalElevatorOpener, BottomNavigation, measureBtn, RoomAmenitiesSidebar },
  
  computed: {
      ...mapState({
        selectedBuilding: state => state.space.selectedBuilding,
        darkTheme: state => state.ui.darkTheme,
        showPhotoReview: state => state.ui.showPhotoReview,
      }),      
  },

  methods: {
    ...mapMutations([ 'setUseBetaGIS'    ]),
  },

  created: function () {
    let useBeta = jscookie.get('if_use_beta_gis')
    //console.log("useBeta Cookie ", useBeta)
    if (jscookie.get('if_use_beta_gis') == 'true') {      
      this.setUseBetaGIS(true)
    }
  }
}
</script>

<style>
@import url('https://js.arcgis.com/3.38/esri/css/esri.css');
@import url("https://js.arcgis.com/3.38/esri/themes/calcite/dijit/calcite.css");
@import url("https://js.arcgis.com/3.38/esri/themes/calcite/esri/esri.css");
#app {
  margin-top: 0px;
  height: 100%;
  overflow-y: hidden !important;
  overflow-x: hidden;
}

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey; 
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .1); 
} 

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, .3);  
}

</style>



// WEBPACK FOOTER //
// src/App.vue